import { render, staticRenderFns } from "./CapabilityCard.vue?vue&type=template&id=7347444a&scoped=true"
import script from "./CapabilityCard.vue?vue&type=script&lang=js"
export * from "./CapabilityCard.vue?vue&type=script&lang=js"
import style0 from "./CapabilityCard.vue?vue&type=style&index=0&id=7347444a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7347444a",
  null
  
)

export default component.exports